import {
  VARIATION,
  BASE_CONTRACT,
  VARIATION_TYPES,
} from "../../../utils/constants";

export function getTableField(string) {
  switch (string) {
    case "Base Contract":
      return BASE_CONTRACT;
    case "Variations":
      return VARIATION;
    case "Contra Charges":
      return "contra";
    default:
      return "";
  }
}

export function isVariation(string) {
  return [VARIATION, "variation"].includes(string?.toLowerCase());
}

export function getParentItemById(itemId, itemData) {
  return itemData.find((item) => item.id === itemId) || null;
}

export const isNewPlaceholderLineItem = (id) => `${id}`.startsWith("new_");

export const isEmptyMultiVari = (line, childItemsKeyName = "childitems") =>
  line?.extra_info?.variation_type === VARIATION_TYPES.MULTI &&
  line[childItemsKeyName]?.length === 1 &&
  isNewPlaceholderLineItem(line[childItemsKeyName][0].id);

export const isMultiWithNoChild = (data) =>
  data?.extra_info?.variation_type === VARIATION_TYPES.MULTI &&
  data?.childitems?.length === 0;

export const tableDataExcludingEmptyMulti = (tableData) =>
  tableData?.filter((item) => !isMultiWithNoChild(item));

export const getNewUpdatedVariationLineItems = (lineItem, data) => {
  const matchId = lineItem?.parent_id || lineItem.id;
  const updatedItem = data.find((item) => item.id === matchId);
  return updatedItem ? { ...lineItem, ...updatedItem } : lineItem;
};
